var _a, _b;
import ctaTokenIcon from '../assets/images/icons/common/icon-cta-token.png';
import ethIcon from '../assets/images/icons/common/icon-eth.png';
import imxIcon from '../assets/images/icons/common/icon-imx.png';
import usdcIcon from '../assets/images/icons/common/icon-usdc.png';
import { CurrencyTokenSymbol } from '../data/currency-tokens/currency-tokens';
import { BlockchainType } from '../hooks/blockchain/use-transfer';
export var currencyTokenAssets = (_a = {},
    _a[CurrencyTokenSymbol.CTA] = ctaTokenIcon,
    _a[CurrencyTokenSymbol.USDC] = usdcIcon,
    _a[CurrencyTokenSymbol.IMX] = imxIcon,
    _a[CurrencyTokenSymbol.ETH] = ethIcon,
    _a);
export var blockchainAssets = (_b = {},
    _b[BlockchainType.ETH] = ethIcon,
    _b[BlockchainType.IMX] = imxIcon,
    _b);
